import { Store } from 'store/index';
import getLocaleSelector from './getLocaleSelector';

const LANGUAGE_PREFIXES: {
  [key: string]: string;
} = {
  'en-CA': '/en',
  'en-US': '/en',
  'fr-CA': '/fr',
  'fr-CH': '/fr',
  'fr-BE': '/fr',
  'de-CH': '/de',
  'nl-BE': '/nl',
};

const getLanguagePrefix = (store: Store) => {
  const locale = getLocaleSelector(store);
  return LANGUAGE_PREFIXES[locale] || '';
};

export default getLanguagePrefix;
